import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const JoinRoom: React.FC = () => {
    const [roomCode, setRoomCode] = useState('');
    const [playerName, setPlayerName] = useState('');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // URL'den oda kodunu al
    useEffect(() => {
        const roomFromUrl = searchParams.get('room');
        if (roomFromUrl) {
            setRoomCode(roomFromUrl);
        }
    }, [searchParams]);

    const joinRoom = () => {
        if (roomCode.trim() && playerName.trim()) {
            navigate(`/room/${roomCode.toUpperCase()}?player=${encodeURIComponent(playerName)}`);
        }
    };

    const goBack = () => {
        navigate('/');
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-8">
            <div className="max-w-md w-full text-center">
                <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Odaya Katıl</h1>

                <div className="bg-gray-800 rounded-lg p-8 space-y-6">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-white text-sm font-medium mb-2">
                                Oyuncu Adınız
                            </label>
                            <input
                                type="text"
                                value={playerName}
                                onChange={(e) => setPlayerName(e.target.value)}
                                placeholder="Adınızı girin"
                                className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none"
                                maxLength={20}
                            />
                        </div>

                        <div>
                            <label className="block text-white text-sm font-medium mb-2">
                                Oda Kodu
                            </label>
                            <input
                                type="text"
                                value={roomCode}
                                onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                                placeholder="Oda kodunu girin"
                                className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none"
                                maxLength={6}
                            />
                        </div>
                    </div>

                    <div className="flex space-x-3">
                        <button
                            onClick={goBack}
                            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                        >
                            Geri
                        </button>
                        <button
                            onClick={joinRoom}
                            disabled={!roomCode.trim() || !playerName.trim()}
                            className="flex-1 bg-wordle-green hover:bg-green-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                        >
                            Odaya Katıl
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JoinRoom;